<template>
  <a-modal :open="open" @cancel="closeForm">
    <a-form layout="vertical" :model="filters">

      <a-form-item label="ФИО">
        <a-input v-model:value="filters.name" placeholder="Фио"/>
      </a-form-item>

      <a-form-item label="Почта">
        <a-input v-model:value="filters.email" placeholder="Почта" />
      </a-form-item>
    </a-form>

    <template #footer>
      <a-row justify="end" :gutter="8">
        <a-col>
          <a-button :class="'secondary-button'" @click="closeForm">Отменить</a-button>
        </a-col>
        <a-col>
          <a-button :class="'primary-button'" @click="updateFilters">Применить</a-button>
        </a-col>
      </a-row>
    </template>
  </a-modal>
</template>

<script>
import {reactive, ref} from "@vue/runtime-core";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";

export default {
  props: {
    open: Boolean,
    groups: Array,
  },
  setup(props, context) {
    const currentFiltersLine = ref('');
    const store = useStore();

    const storedFilters = computed(() => store.state.users.filters);

    const filters = reactive({
      name: storedFilters.value.name ?? '',
      job_title: storedFilters.value.job_title ?? '',
      department: storedFilters.value.department ?? '',
      online_from: storedFilters.value.online_form ?? '',
      created_at: storedFilters.value.created_at ?? '',
      email: storedFilters.value.email ?? '',
      telephone: storedFilters.value.telephone ?? '',
      groups: storedFilters.value.groups ?? [],
      current_group: storedFilters.value.current_group ?? null,
      without_group_only: storedFilters.value.without_group_only ?? false,
    });

    const filterStringLabels = {
      name: 'ФИО',
      job_title: 'Должность',
      department: 'Подразделение',
      online_from: 'Дата входа',
      created_at: 'Дата создания',
      email: 'Почта',
      telephone: 'Телефон',
      groups: 'Группы',
      without_group_only: 'Без группы',
    }

    const buildInputLineString = () => {
      currentFiltersLine.value = '';
      Object.entries(filterStringLabels).map(
          ([key, value]) => {
            if (filters[key] && key !== 'groups') {
              let newString = `${value}: ${filters[key]}`;

              if (newString) {
                currentFiltersLine.value = (currentFiltersLine.value ? currentFiltersLine.value + ', ' : '') + `${newString}`
              }
            }
          }
      );
    }

    const updateFilters = () => {
      buildInputLineString();

      store.dispatch('users/setUserFilters', {
        filters: filters,
        filterString: currentFiltersLine,
      });
    }

    const closeForm = () => {
      context.emit('close');
    }

    return {
      filters,
      updateFilters,
      closeForm,
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.ant-form-item-label) {
  padding-bottom: 4px !important;
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}
</style>